import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '@app/shared/shared.module';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { DocumentGeneratorAnalysisComponent } from
  '@app/routes/automation/documentgeneratoranalysis/documentgeneratoranalysis.component';
import { TagManagementComponent } from '@app/routes/automation/tag-management/tag-management.component';
import { TagEditModalComponent } from '@app/routes/automation/tag-management/tag-edit-modal/tag-edit-modal.component';
import { TagDefinitionDetailsComponent } from '@app/routes/automation/tag-management/tag-definition-details/tag-definition-details.component';
import { TagDefinitionEditModalComponent } from '@app/routes/automation/tag-management/tag-definition-edit-modal/tag-definition-edit-modal.component';


const routes: Routes = [
  { path: 'documentgeneratoranalysis', component: DocumentGeneratorAnalysisComponent },
  { path: 'tag-management', component: TagManagementComponent }
];


@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    NgxSmartModalModule.forRoot(),
    ProgressbarModule.forRoot()
  ],
  declarations: [
    DocumentGeneratorAnalysisComponent,
    TagManagementComponent,
    TagEditModalComponent,
    TagDefinitionDetailsComponent,
    TagDefinitionEditModalComponent
  ],
  exports: [
    RouterModule
  ]
})
export class AutomationModule { }
